import { render, staticRenderFns } from "./Panorama.vue?vue&type=template&id=58018b9e"
import script from "./Panorama.vue?vue&type=script&lang=js"
export * from "./Panorama.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports